module.exports = __webpack_public_path__ + "media/budapest/bastion_cross_stairs-90a4fe81.jpg";